var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualnosci",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aktualnosci---post---1",
    transform: "translate(-280.000000, -5158.000000)",
    fill: "#E20071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "artykul-copy-2",
    transform: "translate(240.000000, 4578.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like",
    transform: "translate(0.000000, 558.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(40.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6956522,2 C12.7232733,2.00026234 10.9141871,3.13410697 10,4.94300155 C8.86597807,2.70910974 6.40666998,1.56301907 4.03893372,2.16501595 C1.67119747,2.76701284 0.00488779665,4.96204171 0,7.48550129 C0,10.514001 1.8173913,13.2815007 4.16521739,15.5540005 C5.9764895,17.2152544 7.9293919,18.7033309 10,20 C12.05508,18.6794437 14.0060845,17.1928134 15.8347826,15.5540005 C18.4434783,13.0880007 20,10.514001 20,7.48550129 C20,6.02987637 19.4410124,4.63393573 18.4461291,3.60507558 C17.4512457,2.57621543 16.1020527,1.99880773 14.6956522,2 Z",
    id: "Heart"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart_filled.3dae49b39dff15d62cc3028d71ef94ab.svg";
export { ForwardRef as ReactComponent };